/* Talas reveal (loaded with `defer` from layout/theme.liquid, CSS in assets/talas-reveal.css).
   Generic scroll entrance for below-the-fold blocks nobody else reveals. Already handled elsewhere and deliberately NOT touched here:
     - assets/talas-motion.js   (.tm-rv: home heads/model tiles/categories, branch cards, footer brand, Fits models, cart lines)
     - assets/talas-catalog.js  (.tc-reveal: product cards in every grid, incl. AJAX-loaded collection pages)
     - assets/talas-pdp.js      ([data-reveal]: PDP sections and the "more parts" grid)
     - FAQ (.tfaq has its own slide-in) and review cards (.trv__q fade in themselves; only the section wrapper .trv__wrap is revealed here)
   Rules: hidden state only after html.tr-ready; only elements whose top is below the first viewport at load are hidden (header, hero, buy box,
   gallery, collection cover are never touched, so LCP is unaffected); once per element; stagger 60ms within a batch; reduced motion = nothing. */
(function () {
  'use strict';
  if (window.__talasReveal) return;
  window.__talasReveal = true;

  var root = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  if (mq.matches || !('IntersectionObserver' in window)) return;

  /* staggered cards / repeated items, then whole blocks. Add data-tr to any element to opt in. */
  var TARGETS = [
    '.tw__item',                                /* Why Talas items (home) */
    '.ts__step, .ts__item, .ts__story > .ts__h, .ts__why > .ts__h, .ts__lede', /* About: story timeline + why list */
    '.tsrc__in',                                /* sourcing band */
    '.trv__wrap',                               /* reviews: section-level only, cards keep their own fade */
    '.section-blocks > .block > .container',    /* About: paragraph/image, statistics, trademarks */
    '[data-tr]'
  ].join(',');
  var SKIP = '.tc-reveal, [data-reveal], .tm-rv, [data-tm-rv], .th-model, .th-cat, .th-head, .th-prod__head, .tc-fbrand, .tc-facc, .tsr-list li, ' +
             '.tcol-empty, .cart-section .line-item, .pdx-fits__model, .branch-card, .tfaq, .tfaq *, .tr-hide, header, .tc-pill, .tc-mobile, ' +
             '.pdx-hero, .product-wrapper, .tcol-hero, h1, .drawer, .modal, [hidden]';
  var EASE_DONE = 560;   /* ms: .5s transition + margin, then classes are dropped so hover transitions are not delayed */
  var STEP = 60, MAXD = 360;

  var io = null, pending = [];

  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function reveal(n, delay) {
    if (!n.classList.contains('tr-hide') || n.classList.contains('tr-in')) return;
    io.unobserve(n);
    pending = pending.filter(function (p) { return p !== n; });
    n.style.setProperty('--tr-d', delay + 'ms');
    n.classList.add('tr-in');
    setTimeout(function () {
      n.classList.remove('tr-hide', 'tr-in');
      n.style.removeProperty('--tr-d');
    }, EASE_DONE + delay);
  }

  function arm(list) {
    var vh = window.innerHeight;
    list.forEach(function (n) {
      if (n.classList.contains('tr-hide') || n.closest(SKIP)) return;
      var r = n.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      if (r.top <= vh * 0.98) return;               /* first viewport (and anything above it) is never hidden */
      if (n.parentElement && n.parentElement.closest('.tr-hide')) return; /* no double-hiding of nested targets */
      n.classList.add('tr-hide');
      pending.push(n);
      io.observe(n);
    });
  }

  function scan(ctx) {
    var list = [];
    if (ctx.nodeType !== 1) return;
    if (ctx.matches(TARGETS)) list.push(ctx);
    list = list.concat(qa(TARGETS, ctx));
    if (list.length) arm(list);
  }

  function boot() {
    io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (e) { return e.isIntersecting; }).sort(function (a, b) {
        return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left;
      });
      batch.forEach(function (e, i) { reveal(e.target, Math.min(i * STEP, MAXD)); });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

    root.classList.add('tr-ready');
    scan(document.body);

    /* anything already scrolled PAST (fast jump, anchor link, Lenis scrollTo) never intersects again: show it, no animation needed */
    var t = 0;
    window.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        pending.slice().forEach(function (n) { if (n.getBoundingClientRect().bottom < 0) reveal(n, 0); });
      }, 150);
    }, { passive: true });

    /* nodes added later (AJAX grids, Shopify section re-render): re-observe only what was inserted */
    if ('MutationObserver' in window) {
      var q = [], sched = 0;
      new MutationObserver(function (muts) {
        muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) q.push(n); }); });
        if (q.length && !sched) sched = requestAnimationFrame(function () { sched = 0; var l = q; q = []; l.forEach(scan); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* reduced motion switched on mid-session: show everything now */
    var off = function () {
      if (!mq.matches) return;
      qa('.tr-hide').forEach(function (n) { n.classList.remove('tr-hide', 'tr-in'); });
      root.classList.remove('tr-ready');
    };
    if (mq.addEventListener) mq.addEventListener('change', off); else if (mq.addListener) mq.addListener(off);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
